<template>
  <v-container class="fill-height">
    <v-row class="align-center justify-center">
      <v-col cols="auto">
        <v-progress-circular :size="64" :width="6" color="primary" indeterminate/>
      </v-col>
    </v-row>
  </v-container>
</template>

